import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const token = params.get('token');
    if (!token) return setStatus('invalid');

    axiosInstance.post('/auth/verify-email', { token })
      .then(() => setStatus('success'))
      .catch(() => setStatus('failed'));
  }, [params]);

  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-base-100 shadow-xl rounded text-center">
      {status === 'checking' && <p className="text-gray-500">Bestätige E-Mail-Adresse…</p>}
      {status === 'success' && <p className="text-green-600 text-lg font-bold">✅ Deine E-Mail wurde erfolgreich bestätigt! Ein Administrator prüft jetzt deine Regsitrierung und wird dich freischalten! Du bekommst eine E-Mail sobald dieser Prozess beendet ist!</p>}
      {status === 'failed' && <p className="text-red-600 text-lg font-bold">❌ Der Verifizierungslink ist ungültig oder abgelaufen.</p>}
      {status === 'invalid' && <p className="text-red-600 text-lg font-bold">❌ Kein Token übergeben.</p>}
    </div>
  );
};

export default VerifyEmail;
